export function avulsoFlAceiteAdesaoTag(value: unknown): 0 | 1 {
  return value === 1 || value === true ? 1 : 0;
}

export function withFlAceiteAdesaoTag<T extends Record<string, unknown>>(
  body: T,
  options: { include: boolean; accepted: unknown },
): T & { flAceiteAdesaoTag?: 0 | 1 } {
  if (!options.include) {
    return body;
  }

  return {
    ...body,
    flAceiteAdesaoTag: avulsoFlAceiteAdesaoTag(options.accepted),
  };
}
